import React from "react";
import DefaultLayout from "../../../../components/generic/Layout";
import MetaTags from "../../../../components/generic/MetaTags";
import Step1 from "../../../../components/Onboarding/Step1";
import useVerifyUser from "../../../../utils/useVerifyUser";
import Navbar from "../../../../components/Landing/LandingNavbar";

const SOPType = () => {
  useVerifyUser();

  return (
    <>
      <MetaTags PageName="Step-1 | New SOP"></MetaTags>
      <section className="bg-white h-screen">
        <Navbar />
        <Step1 />
      </section>
    </>
  );
};

export default SOPType;
